import headerLogo from './headerLogo.svg';
import headerLogoWhite from './headerLogoWhite.svg';
import recapLogo from './recapLogo.svg';

type Props = React.ImgHTMLAttributes<HTMLImageElement> & { iconOnly?: boolean };

export default function RecapLogo({ iconOnly = false, ...imgProps }: Props) {
  if (iconOnly) {
    return <img alt="Recap" src={recapLogo} height="40" width="40" {...imgProps} />;
  }

  return (
    <picture>
      <source srcSet={headerLogoWhite} media="(prefers-color-scheme: dark)" />
      <img alt="Recap" src={headerLogo} height="32" width="102" {...imgProps} />
    </picture>
  );
}
